<i18n src="../../../locales/lang.json"></i18n>

<template>
  <div class="card" v-bind:id="getId()" style="float:left; width:200px; margin-left:15px;">
    <div class="card-header bg-dark text-white header-elements-inline">
      <h6 class="card-title">{{config.text}}</h6>
      <div class="header-elements">
        <div class="list-icons">
          <a class="list-icons-item" @click="removeMe" data-action="remove"></a>
        </div>
      </div>
    </div>
    <div class="card-body text-center">



      <div class="text-center">

        <div class="form-group">
          <label>Display week numbers:</label>
          <div class="input-group"  v-bind:id="'calenderparent' + getId()">
            <span class="input-group-prepend">
              <span class="input-group-text"><i class="icon-calendar22"></i></span>
            </span>
            <input type="text" v-bind:id="'calender' + getId()" class="form-control" v-bind:value="getDate">
          </div>
        </div>




        <div>
          <i class="icon-calendar22"></i>


          <span class="input-group-prepend" style="display:inline-block">
            <span class="input-group-text" style="border-top-right-radius: 0; border-bottom-right-radius: 0;"><i class="icon-calendar22"></i></span>
          </span>
          <span style="margin-left:10px;border:1px solid #ccc;border-left:0">{{startDate}}</span>
        </div>

        <i class="icon-calendar22" style="margin-right:3px;"></i>{{startDate}}<br />
        To<br />
        <i class="icon-calendar22" style="margin-right: 3px;"></i>{{endDate}}
      </div>

      

    </div>

  </div>
</template>

<script>

  var config =
  {
    customstyle: "background-color:#92D050",
    customclass: "",
    abbreviation: "T1",
    data: 8,
    text: "Team 1",
    icon: null

  }

  var startDate = "";
  var endDate = "";

  export default {
    name: "display-date",
    components: {
      
    },
    props: {
      enableedit: {
        required: false,
        type: String,
        default: "false"
      },
      type: {
        required: false,
        type: String,
        default: ""
      },
    },
    data() {
      return {
        config,
        startDate,
        endDate
      };
    },
    
    methods: {
      test() {
        //alert('Checking value for:' + '#calender' + this.getId());
        //alert($('#calender' + this.getId()).val());
      },
      getId() {
        return "child_" + this._uid;
      },
      toggleActivation() {

      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      removeMe() {
        this.$emit('remove', this.getId());
      },
      setConfig(config) {
        this.config = config;
        var dateValuesString = this.config.data;
        var dateValuesArr = dateValuesString.split(',');
        this.startDate = dateValuesArr[0];
        if (dateValuesArr.length > 1) {
          this.endDate = dateValuesArr[1];
        }
      },
      rendered() {
        $('#calender' + this.getId()).daterangepicker({
          parentEl: '#calenderparent' + this.getId(),
          showWeekNumbers: true
        });
      }
    },
    computed: {
      getDate: function () {
        var dString = this.startDate;
        if (this.endDate != "") {
          dString += " " + this.endDate;
        }
        return dString;
      }
    },
    mounted() {
      // Display week numbers
      
    },
    watch: {
     
    },
    created() {
      alert('created:Checking value for:' + '#calender' + this.getId());
      alert($('#calender' + this.getId()).val());
    },
  };

</script>

<style scoped>
  .card-header.bg-dark {
    background-color: #f6f7f7 !important;
    color: black !important;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .card-body{
      min-height:150px;
  }

  @media screen and (max-width:768px) {
    .card {
      margin-left: 5px !important;
      width: 185px !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/filter/displayers/display-date.vue